import { FormContainer } from '@wyz/ui';
import { useOnUpdate } from '@wyz/utils';
import { memo, useCallback, useEffect, useEffectEvent } from 'react';
import { useForm } from 'react-hook-form';
import { IUserCustomer } from '~/common/types';
import { IBaseFilter } from '~/purchase/types';

type Props = React.PropsWithChildren<{
  defaultValues: IBaseFilter;
  onFilter: (payload: { filters: IBaseFilter }) => void;
  customer: IUserCustomer;
}>;

function FilterBarFormContainer({
  defaultValues,
  onFilter,
  children,
  customer,
}: Props) {
  const methods = useForm<IBaseFilter>({
    defaultValues: defaultValues,
  });

  const resetForm = useEffectEvent(() => {
    methods.reset();
  });

  useOnUpdate(() => {
    if (customer.id) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      resetForm();
    }
  }, [customer.id]);

  const handleOnsubmit = useCallback(
    (formData: IBaseFilter) => {
      onFilter({ filters: formData });
    },
    [onFilter],
  );

  useEffect(() => {
    const subscription = methods.watch(() =>
      methods.handleSubmit(handleOnsubmit)(),
    );
    return () => subscription.unsubscribe();
  }, [methods, onFilter, handleOnsubmit]);

  return (
    <FormContainer methods={methods} submitHandler={handleOnsubmit}>
      {children}
    </FormContainer>
  );
}

export default memo(FilterBarFormContainer);
